import { usePopup } from "hooks/usePopup";
import { useSoundPath } from "hooks/useSoundPath";

const PageHeaderWithdraw = () => {
  const setPopupHook = usePopup();
  const playSound = useSoundPath();

  return (
    <>
      <button
        className="page-header__user-popup-action"
        onClick={() => {
          playSound("main");
          setPopupHook({type: 'withdraw-funds'});
        }}
      >
        Withdraw Funds
      </button>
    </>
  );
};

export default PageHeaderWithdraw;
